import { useEffect, useState } from "react";
import api from "../api/api";
import { useLocation } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { useNavigate } from "react-router-dom";
import { FaMapMarkerAlt, FaStar, FaStarHalfAlt, FaRegStar, FaSearch, FaUndo } from "react-icons/fa";
import { Star, Tag, MapPin, Hotel, ArrowRight } from "lucide-react";
import FeaturedLoader from "../components/Loaders/FeaturedLoader";
import { Wifi, Car, Utensils, Dumbbell, Waves, } from "lucide-react";
import { BadgePercent, TicketPercent, Sparkles, Crown, Zap, ShieldCheck, } from "lucide-react";

export default function HotelSearch() {
    const [hotels, setHotels] = useState([]);
    const location = useLocation();
    const searchData = location.state;
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);
    const [loadedImages, setLoadedImages] = useState({});



    const amenityIcons = {
        "Free WiFi": <Wifi size={12} />,
        "Free Parking": <Car size={12} />,
        Restaurant: <Utensils size={12} />,
        "Fitness Centre": <Dumbbell size={12} />,
        "Swimming Pool": <Waves size={12} />,
    };





    // Fetch hotels
    useEffect(() => {
        const fetchHotels = async () => {
            setLoading(true);
            setError(false);

            try {
                const res = await api.get("/hotels", {
                    params: {
                        destination: searchData?.destination
                    }
                });

                setHotels(res.data);
            } catch (err) {
                console.error(err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        fetchHotels();
    }, [searchData]);

    return (
        <div>


            <PageHeader
                title="Available Hotels"
                subtitle={`${hotels.length} hotels found matching your search`}
            />

            <div className="bg-slate-50 dark:bg-gray-950 min-h-screen py-12">
                <div className="max-w-7xl mx-auto px-6">

                    <div className="text-center mb-12">
                        <span className="inline-block px-3 py-1 text-xs font-semibold bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 rounded-full mb-3">
                            Hotel Search
                        </span>

                        <h2 className="text-4xl font-bold text-slate-800 dark:text-white">
                            Available Hotels
                        </h2>

                        <p className="text-gray-500 dark:text-gray-400 mt-3">
                            Found {hotels.length} hotels matching your search
                        </p>
                    </div>

                    {loading ? (
                        <div className="flex flex-col items-center justify-center py-28 text-center">

                            <div className="relative w-24 h-24 mb-6">

                                <div className="absolute inset-0 rounded-full border-4 border-blue-100 dark:border-blue-900"></div>

                                <div className="absolute inset-0 rounded-full border-4 border-t-blue-600 border-r-transparent border-b-transparent border-l-transparent animate-spin"></div>

                                <div className="absolute inset-0 flex items-center justify-center">
                                    <div className="w-10 h-10 bg-blue-500 rounded-lg animate-pulse"></div>
                                </div>

                            </div>

                            <h3 className="text-lg font-semibold text-gray-700 dark:text-white">
                                Searching the best hotels
                            </h3>

                            <p className="text-gray-500 dark:text-gray-400 mt-2">
                                Finding perfect stays for your destination...
                            </p>

                            <div className="flex gap-1 mt-4">
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></span>
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:0.1s]"></span>
                                <span className="w-2 h-2 bg-blue-500 rounded-full animate-bounce [animation-delay:0.2s]"></span>
                            </div>

                        </div>
                    ) : error ? (
                        <div className="text-center py-20">
                            <p className="text-red-500 text-lg">Something went wrong</p>
                        </div>

                    ) : hotels.length > 0 ? (
                        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6">

                            {hotels.map((hotel) => (
                                <div
                                    key={hotel.id}
                                    onClick={() => navigate(`/hotels/${hotel.slug}`)}
                                    className="
        group
        rounded-[32px]
        transition
        duration-500
        cursor-pointer
        h-full
    ">


                                    {/* Skeleton Card */}
                                    {!loadedImages[hotel.id] && (
                                        <div className="
                    rounded-[32px]
                    overflow-hidden
                    bg-white
                    shadow-lg
                    animate-pulse
                ">

                                            {/* Image Skeleton */}
                                            <div className="
                        h-[320px]
                        bg-gradient-to-r
                        from-gray-200
                        via-gray-100
                        to-gray-200
                    "></div>


                                            {/* Content Skeleton */}
                                            <div className="p-5 space-y-4">

                                                <div className="h-5 bg-gray-200 rounded w-3/4"></div>

                                                <div className="h-3 bg-gray-200 rounded w-full"></div>

                                                <div className="h-3 bg-gray-200 rounded w-5/6"></div>


                                                <div className="flex gap-2">
                                                    <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
                                                    <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
                                                </div>


                                                <div className="border-t pt-4 flex justify-between">
                                                    <div className="h-8 w-28 bg-gray-200 rounded"></div>
                                                    <div className="h-5 w-20 bg-gray-200 rounded"></div>
                                                </div>

                                            </div>

                                        </div>
                                    )}



                                    {/* Actual Card */}
                                    <div
                                        className={`
                    transition-all
                    duration-700
                    ${loadedImages[hotel.id]
                                                ? "opacity-100 translate-y-0"
                                                : "opacity-0 hidden"
                                            }
                `}
                                    >

                                        <a href={`/hotels/${hotel.slug ?? hotel.id}`}>

                                            <div className="relative overflow-hidden rounded-t-[140px]">


                                                <img
                                                    src={`https://uaediscountedhotels.com/uploads/hotels/${hotel.image}`}
                                                    alt={hotel.name}
                                                    onLoad={() =>
                                                        setLoadedImages((prev) => ({
                                                            ...prev,
                                                            [hotel.id]: true,
                                                        }))
                                                    }
                                                    className="
                                w-full
                                h-[320px]
                                object-cover
                                transition-all
                                duration-700
                                group-hover:scale-110
                            "
                                                />

                                                {/* Gradient Overlay */}
                                                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/20 to-transparent"></div>

                                                {/* Bottom Content */}
                                                <div className="absolute bottom-0 left-0 right-0 p-5">

                                                    {/* Offer Badge */}
                                                    <div className="flex items-center justify-between mb-3">

                                                        <div className="relative">

                                                            {/* Pulse Animation */}
                                                            <span className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-30"></span>

                                                            <span
                                                                className={`
            floating-badge relative inline-flex items-center gap-2 rounded-full px-4 py-2 shadow-xl
            transition-all duration-300 group-hover:scale-105
            ${Number(hotel.price_per_night) <= 150
                                                                        ? "bg-gradient-to-r from-red-600 to-red-500 text-white"
                                                                        : Number(hotel.price_per_night) <= 250
                                                                            ? "bg-gradient-to-r from-green-600 to-green-500 text-white"
                                                                            : "bg-gradient-to-r from-red-600 via-red-500 to-green-600 text-white"
                                                                    }
        `}
                                                            >
                                                                <span className="text-lg animate-bounce">
                                                                    {Number(hotel.price_per_night) <= 150 ? (
                                                                        <BadgePercent className="w-5 h-5 text-white animate-pulse" />
                                                                    ) : (
                                                                        <Crown className="w-5 h-5 text-white animate-pulse" />
                                                                    )}
                                                                </span>

                                                                <div className="leading-tight">
                                                                    <p className="text-[9px] uppercase tracking-widest text-white/80">
                                                                        Limited Time
                                                                    </p>

                                                                    <p className="text-xs font-bold">
                                                                        {Number(hotel.price_per_night) <= 150
                                                                            ? "Best Price"
                                                                            : Number(hotel.price_per_night) <= 250
                                                                                ? "Save Today"
                                                                                : "Exclusive Deal"}
                                                                    </p>
                                                                </div>
                                                            </span>

                                                        </div>

                                                        <div className="flex items-center gap-1 bg-white/20 backdrop-blur-md px-2.5 py-1 rounded-full">
                                                            <Star
                                                                size={12}
                                                                className="fill-[#FFD54A] text-[#FFD54A]"
                                                            />
                                                            <span className="text-white text-xs font-medium">
                                                                {hotel.rating}
                                                            </span>
                                                        </div>

                                                    </div>

                                                    {/* Hotel Name */}
                                                    <h3 className="text-white text-lg font-semibold mb-1 line-clamp-1">
                                                        {hotel.name}
                                                    </h3>

                                                    {/* Location */}
                                                    <p className="text-white/80 text-xs flex items-center gap-1">
                                                        <MapPin size={12} />
                                                        {hotel.location}
                                                    </p>

                                                </div>

                                            </div>

                                            {/* Content */}

                                            <div className="p-5 rounded-t-none rounded-b-2xl border border-[#DDD2BA] bg-[#FCFAF5]">

                                                {/* Description */}
                                                <p className="text-gray-500 text-sm leading-6 line-clamp-3 mb-5">
                                                    {hotel.short_description ||
                                                        "Experience premium accommodation with world-class facilities and exclusive hotel offers."}
                                                </p>

                                                {/* Amenities */}
                                                <div className="flex flex-wrap gap-2 mb-5">
                                                    {hotel.amenities?.slice(0, 3).map((item, index) => (
                                                        <span
                                                            key={index}
                                                            className="inline-flex items-center gap-1 text-[11px] bg-[#EFE7D5] text-[#0F766E] px-2.5 py-1 rounded-full"
                                                        >
                                                            {amenityIcons[item] || null}
                                                            {item}
                                                        </span>
                                                    ))}
                                                </div>

                                                {/* Footer */}
                                                <div className="border-t border-[#DDD2BA] pt-5 flex items-center justify-between">

                                                    <div>

                                                        <p className="text-2xl font-semibold text-[#1F2937]">
                                                            AED {Number(hotel.price_per_night).toLocaleString()}
                                                        </p>

                                                        <p className="text-[11px] uppercase tracking-wider text-gray-500">
                                                            Per Night
                                                        </p>

                                                    </div>

                                                    <a
                                                        href={`/hotels/${hotel.slug}`}
                                                        className="text-[#0F766E] text-sm font-medium border-b border-[#0F766E] pb-1 transition-all duration-300 hover:text-[#B89442] hover:border-[#B89442]"
                                                    >
                                                        View Deal →
                                                    </a>

                                                </div>

                                            </div>

                                        </a>

                                    </div>


                                </div>
                            ))}

                        </div>
                    ) : (
                        <p className="text-center text-gray-500 dark:text-gray-400 py-20">
                            No hotels found
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}